import http from 'utils/http';

export const fetchCSVReport = ({
  type, query, bulk, tz,
}) => http.get(`v1/organizations/{{organizationId}}/reporting/${type}/${bulk ? 'bulk/' : ''}export/?${query}&tz=${tz}`).then((res) => res.data);
